import Comics from './generateParams/Comics';
import Matching from './generateParams/Matching';
import Order from './generateParams/Order';
import PaintBoxes from './generateParams/PaintBoxes';
import Picture from './generateParams/Picture';
import Questions from './generateParams/Questions';
import YesNo from './generateParams/YesNo';
import ManyAnsQuestion from './generateParams/ManyAnsQuestion';

import matchingComp from './isCompleted/match';
import orderComp from './isCompleted/order';
import paintComp from './isCompleted/paint';
import picsComp from './isCompleted/pics';
import questionComp from './isCompleted/question';
import yesnoComp from './isCompleted/yesno';
import manyansquestionComp from './isCompleted/manyansquestion';

import message from './message';

function generateTask(minigameData, state){
    if(!minigameData.generateParams){
        switch(minigameData.minigameType){
            case 'Comics':
                minigameData.generateParams = Comics;
                minigameData.isCompleted = () => true;
                break;
            case 'ManyAnsQuestion':
                minigameData.generateParams = ManyAnsQuestion;
                minigameData.isCompleted = manyansquestionComp;
                break;
            case 'MatchPicsMinigame':
                minigameData.generateParams = Matching;
                minigameData.isCompleted = matchingComp;
                break;
            case 'OrderListMinigame':
                minigameData.generateParams = Order;
                minigameData.isCompleted = orderComp;
                break;
            case 'PaintBoxesMinigame':
                minigameData.generateParams = PaintBoxes;
                minigameData.isCompleted = paintComp;
                break;
            case 'SelectManyPicsMinigame':
                minigameData.generateParams = Picture;
                minigameData.isCompleted = picsComp;
                break;
            case 'Intro':
            case 'Question':
                minigameData.generateParams = Questions;
                minigameData.isCompleted = questionComp;
                break;
            case 'YesNo':
                minigameData.generateParams = YesNo;
                minigameData.isCompleted = yesnoComp;
                break;
            default:
                minigameData.generateParams = () => {return {}};
                minigameData.isCompleted = () => true;
        }
    }
    if(!minigameData.messages){
        minigameData.messages = message;
    }

    return minigameData;
    
}

export default generateTask;